import React from 'react'
import { Box, Divider, Grid, useMediaQuery, useTheme } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import { Breakpoints } from '@src/utils/useResponsiveSizes'

export const DiscoPromoContentSkeletonLoader = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(Breakpoints.MD), {
    defaultMatches: true,
  })

  return (
    <>
      {isDesktop ? (
        <Box p={3}>
          <Skeleton
            variant="text"
            width={200}
            height={35}
            style={{ marginBottom: 12 }}
          />

          <Skeleton variant="text" width="40%" height={20} />
          <Skeleton variant="text" width="50%" height={20} />
          <Skeleton
            variant="text"
            width="20%"
            height={20}
            style={{ marginBottom: 20 }}
          />

          <Skeleton
            variant="text"
            width={180}
            height={28}
            style={{ marginBottom: 15 }}
          />

          <Skeleton
            variant="text"
            width={120}
            height={18}
            style={{ marginBottom: 10 }}
          />

          <Grid
            container
            spacing={2}
            alignItems="center"
            style={{ marginBottom: 20 }}
          >
            <Grid item xs={4}>
              <Skeleton variant="rect" width="100%" height={40} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="rect" width="100%" height={40} />
            </Grid>
          </Grid>

          <Skeleton
            variant="text"
            width={180}
            height={18}
            style={{ marginBottom: 20 }}
          />
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
          </Grid>

          {[1, 2, 3].map((row) => (
            <Box key={row} mb={3} borderBottom="1px solid #eee">
              <Grid container spacing={2} style={{ marginBottom: 10 }}>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="90%" height={25} />
                </Grid>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="90%" height={25} />
                </Grid>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="180%" height={25} />
                </Grid>
              </Grid>

              {[1, 2].map((sku) => (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  key={sku}
                  style={{ marginBottom: 12 }}
                >
                  <Grid item xs={2}></Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="text" width="80%" height={22} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="text" width="50%" height={22} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="text" width="60%" height={22} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="rect" width={100} height={35} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="rect" width={180} height={40} />
                  </Grid>
                </Grid>
              ))}
            </Box>
          ))}

          <Box display="flex" justifyContent="center" mt={4} mb={11}>
            <Skeleton variant="rect" width={180} height={40} />
          </Box>
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      ) : (
        <Box p={2}>
          <Box mt={8} mb={6}>
            <Skeleton variant="text" width={160} height={30} />
          </Box>

          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="85%" height={20} />
          <Skeleton variant="text" width="70%" height={20} />
          <Skeleton
            variant="text"
            width="60%"
            height={20}
            style={{ marginBottom: 56 }}
          />

          <Skeleton variant="text" width={160} height={30} />

          <Box display="flex" mt={4} mb={6}>
            <Skeleton
              variant="rect"
              width="100%"
              height={40}
              style={{ marginRight: 8 }}
            />
            <Skeleton variant="rect" width={52} height={40} />
          </Box>

          <Divider style={{ marginBottom: 24 }} />

          <Skeleton variant="text" width={180} height={20} />

          <Box display="flex" mt={4} mb={4}>
            <Skeleton variant="rect" width={500} height={40} />
          </Box>

          <Divider style={{ marginBottom: 16 }} />

          {[...Array(3)].map((_, i) => (
            <Box key={i} mb={3}>
              <Skeleton
                variant="text"
                width={100}
                height={20}
                style={{ marginBottom: 8 }}
              />{' '}
              <Skeleton
                variant="text"
                width={160}
                height={25}
                style={{ marginBottom: 8 }}
              />{' '}
              <Skeleton
                variant="text"
                width="80%"
                height={18}
                style={{ marginBottom: 8 }}
              />
              <Skeleton
                variant="text"
                width="60%"
                height={18}
                style={{ marginBottom: 16 }}
              />
              <Skeleton
                variant="text"
                width={80}
                height={20}
                style={{ marginBottom: 16 }}
              />{' '}
              <Box display="flex" mt={1}>
                <Skeleton
                  variant="rect"
                  width={100}
                  height={40}
                  style={{ marginRight: 12 }}
                />
                <Skeleton variant="rect" width={250} height={40} />
              </Box>
              <Divider style={{ marginTop: 24 }} />
            </Box>
          ))}

          <Box display="flex" justifyContent="center" mt={8} mb={12}>
            <Skeleton variant="rect" width={300} height={45} />
          </Box>
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="100%" height={20} />
        </Box>
      )}
    </>
  )
}

export const DiscoPromoProductsSkeletonLoader = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(Breakpoints.MD), {
    defaultMatches: true,
  })
  return (
    <>
      {isDesktop ? (
        <Box p={3}>
          <Skeleton
            variant="text"
            width={180}
            height={18}
            style={{ marginBottom: 20 }}
          />
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
          </Grid>

          {[1, 2, 3].map((row) => (
            <Box key={row} mb={3} borderBottom="1px solid #eee">
              <Grid container spacing={2} style={{ marginBottom: 10 }}>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="90%" height={25} />
                </Grid>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="90%" height={25} />
                </Grid>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="180%" height={25} />
                </Grid>
              </Grid>

              {[1, 2].map((sku) => (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  key={sku}
                  style={{ marginBottom: 12 }}
                >
                  <Grid item xs={2}></Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="text" width="80%" height={22} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="text" width="50%" height={22} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="text" width="60%" height={22} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="rect" width={100} height={35} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton variant="rect" width={180} height={40} />
                  </Grid>
                </Grid>
              ))}
            </Box>
          ))}

          <Box display="flex" justifyContent="center" mt={4}>
            <Skeleton variant="rect" width={180} height={40} />
          </Box>
        </Box>
      ) : (
        <Box p={3}>
          <Skeleton variant="text" width={180} height={20} />

          <Box display="flex" mt={4} mb={4}>
            <Skeleton variant="rect" width="100%" height={40} />
          </Box>

          <Divider style={{ marginBottom: 16 }} />

          {[...Array(3)].map((_, i) => (
            <Box key={i} mb={3}>
              <Skeleton
                variant="text"
                width={100}
                height={20}
                style={{ marginBottom: 8 }}
              />{' '}
              <Skeleton
                variant="text"
                width={160}
                height={25}
                style={{ marginBottom: 8 }}
              />{' '}
              <Skeleton
                variant="text"
                width="80%"
                height={18}
                style={{ marginBottom: 8 }}
              />
              <Skeleton
                variant="text"
                width="60%"
                height={18}
                style={{ marginBottom: 16 }}
              />
              <Skeleton
                variant="text"
                width={80}
                height={20}
                style={{ marginBottom: 16 }}
              />{' '}
              <Box display="flex" mt={1}>
                <Skeleton
                  variant="rect"
                  width={100}
                  height={40}
                  style={{ marginRight: 12 }}
                />
                <Skeleton variant="rect" width={250} height={40} />
              </Box>
              <Divider style={{ marginTop: 24 }} />
            </Box>
          ))}

          <Box display="flex" justifyContent="center" mt={8} mb={12}>
            <Skeleton variant="rect" width={300} height={45} />
          </Box>
        </Box>
      )}
    </>
  )
}
